import {Injectable} from "@angular/core";
import {Observable, Subject, Subscription} from "rxjs";
import {Apollo} from "apollo-angular";
import {MigrateGqlModel, MigrationErrorGqlModel, MigrationStatusGqlModel} from "./migrate.gql-model";

export interface MigrateStatus {
  progress: number;
  status: string;
  complete: boolean;
}

@Injectable()
export class MigrateService {
  private stepCount: number = 0;
  private currentStep: number = 0;
  private complete: boolean = false;
  private status: string;
  private subscription: Subscription;

  private progressSubject: Subject<MigrateStatus> = new Subject<MigrateStatus>();
  progress: Observable<MigrateStatus> = this.progressSubject.asObservable();

  private errorSubject: Subject<Error> = new Subject<Error>();
  error: Observable<Error> = this.errorSubject.asObservable();

  constructor(private apollo: Apollo) {}

  migrate(projectId: string, environmentName: string) {
    const query = MigrateGqlModel.query;
    const variables = MigrateGqlModel.variables(projectId, environmentName);
    const observable = this.apollo.subscribe({query, variables, fetchPolicy: "no-cache"})
      .pipe(MigrationStatusGqlModel.mapper);

    const subscription = observable.subscribe(
      (result: any) => {
        if (result instanceof MigrationStatusGqlModel) {
          this.currentStep = result.step;
          this.stepCount = result.steps;
          this.status = result.status;
          this.complete = (this.currentStep === this.stepCount);

          if (this.complete && !subscription.closed) {
            subscription.unsubscribe();
          }

          this.progressSubject.next({
            progress: this.currentStep / this.stepCount,
            status: this.status,
            complete: this.complete,
          } as MigrateStatus);
        } else if (result instanceof MigrationErrorGqlModel) {
          this.errorSubject.next(result.error);

          if (!subscription.closed) {
            subscription.unsubscribe();
          }
        }
      },
      (error: Error) => {
        this.errorSubject.next(error);

        if (!subscription.closed) {
          subscription.unsubscribe();
        }
      },
    );

    this.subscription = subscription;
  }
}
